/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { vendorWorkspaceApproveLogControllerCreate } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-create';
import { VendorWorkspaceApproveLogControllerCreate$Params } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-create';
import { vendorWorkspaceApproveLogControllerDelete } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-delete';
import { VendorWorkspaceApproveLogControllerDelete$Params } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-delete';
import { vendorWorkspaceApproveLogControllerFindAll } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-find-all';
import { VendorWorkspaceApproveLogControllerFindAll$Params } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-find-all';
import { vendorWorkspaceApproveLogControllerFindById } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-find-by-id';
import { VendorWorkspaceApproveLogControllerFindById$Params } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-find-by-id';
import { vendorWorkspaceApproveLogControllerSearchCursor } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-search-cursor';
import { VendorWorkspaceApproveLogControllerSearchCursor$Params } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-search-cursor';
import { vendorWorkspaceApproveLogControllerSearchOffset } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-search-offset';
import { VendorWorkspaceApproveLogControllerSearchOffset$Params } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-search-offset';
import { vendorWorkspaceApproveLogControllerUpdate } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-update';
import { VendorWorkspaceApproveLogControllerUpdate$Params } from '../fn/vendor-workspace-approve-log/vendor-workspace-approve-log-controller-update';
import { VendorWorkspaceApproveLogDto } from '../models/vendor-workspace-approve-log-dto';

@Injectable({ providedIn: 'root' })
export class VendorWorkspaceApproveLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorWorkspaceApproveLogControllerFindAll()` */
  static readonly VendorWorkspaceApproveLogControllerFindAllPath = '/api/vendorWorkspaceApproveLog';

  /**
   * 입점사 승인 로그 전체 조회.
   *
   * 입점사 승인 로그 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceApproveLogControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceApproveLogControllerFindAll$Response(params?: VendorWorkspaceApproveLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorWorkspaceApproveLogDto>>> {
    return vendorWorkspaceApproveLogControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 승인 로그 전체 조회.
   *
   * 입점사 승인 로그 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceApproveLogControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceApproveLogControllerFindAll(params?: VendorWorkspaceApproveLogControllerFindAll$Params, context?: HttpContext): Observable<Array<VendorWorkspaceApproveLogDto>> {
    return this.vendorWorkspaceApproveLogControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorWorkspaceApproveLogDto>>): Array<VendorWorkspaceApproveLogDto> => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceApproveLogControllerCreate()` */
  static readonly VendorWorkspaceApproveLogControllerCreatePath = '/api/vendorWorkspaceApproveLog';

  /**
   * 입점사 승인 로그 생성.
   *
   * 입점사 승인 로그을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceApproveLogControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceApproveLogControllerCreate$Response(params: VendorWorkspaceApproveLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceApproveLogDto>> {
    return vendorWorkspaceApproveLogControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 승인 로그 생성.
   *
   * 입점사 승인 로그을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceApproveLogControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceApproveLogControllerCreate(params: VendorWorkspaceApproveLogControllerCreate$Params, context?: HttpContext): Observable<VendorWorkspaceApproveLogDto> {
    return this.vendorWorkspaceApproveLogControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceApproveLogDto>): VendorWorkspaceApproveLogDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceApproveLogControllerSearchOffset()` */
  static readonly VendorWorkspaceApproveLogControllerSearchOffsetPath = '/api/vendorWorkspaceApproveLog/search/offset';

  /**
   * 입점사 승인 로그 오프셋 기반 조회.
   *
   * 입점사 승인 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceApproveLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceApproveLogControllerSearchOffset$Response(params: VendorWorkspaceApproveLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return vendorWorkspaceApproveLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 승인 로그 오프셋 기반 조회.
   *
   * 입점사 승인 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceApproveLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceApproveLogControllerSearchOffset(params: VendorWorkspaceApproveLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.vendorWorkspaceApproveLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceApproveLogControllerSearchCursor()` */
  static readonly VendorWorkspaceApproveLogControllerSearchCursorPath = '/api/vendorWorkspaceApproveLog/search/cursor';

  /**
   * 입점사 승인 로그 커서 기반 조회.
   *
   * 입점사 승인 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceApproveLogControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceApproveLogControllerSearchCursor$Response(params: VendorWorkspaceApproveLogControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return vendorWorkspaceApproveLogControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 승인 로그 커서 기반 조회.
   *
   * 입점사 승인 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceApproveLogControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceApproveLogControllerSearchCursor(params: VendorWorkspaceApproveLogControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.vendorWorkspaceApproveLogControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceApproveLogControllerFindById()` */
  static readonly VendorWorkspaceApproveLogControllerFindByIdPath = '/api/vendorWorkspaceApproveLog/{id}';

  /**
   * 입점사 승인 로그 ID 기반 조회.
   *
   * 입점사 승인 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceApproveLogControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceApproveLogControllerFindById$Response(params: VendorWorkspaceApproveLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceApproveLogDto>> {
    return vendorWorkspaceApproveLogControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 승인 로그 ID 기반 조회.
   *
   * 입점사 승인 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceApproveLogControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceApproveLogControllerFindById(params: VendorWorkspaceApproveLogControllerFindById$Params, context?: HttpContext): Observable<VendorWorkspaceApproveLogDto> {
    return this.vendorWorkspaceApproveLogControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceApproveLogDto>): VendorWorkspaceApproveLogDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceApproveLogControllerDelete()` */
  static readonly VendorWorkspaceApproveLogControllerDeletePath = '/api/vendorWorkspaceApproveLog/{id}';

  /**
   * 입점사 승인 로그 삭제.
   *
   * 입점사 승인 로그을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceApproveLogControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceApproveLogControllerDelete$Response(params: VendorWorkspaceApproveLogControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceApproveLogDto>> {
    return vendorWorkspaceApproveLogControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 승인 로그 삭제.
   *
   * 입점사 승인 로그을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceApproveLogControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceApproveLogControllerDelete(params: VendorWorkspaceApproveLogControllerDelete$Params, context?: HttpContext): Observable<VendorWorkspaceApproveLogDto> {
    return this.vendorWorkspaceApproveLogControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceApproveLogDto>): VendorWorkspaceApproveLogDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceApproveLogControllerUpdate()` */
  static readonly VendorWorkspaceApproveLogControllerUpdatePath = '/api/vendorWorkspaceApproveLog/{id}';

  /**
   * 입점사 승인 로그 수정.
   *
   * 입점사 승인 로그을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceApproveLogControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceApproveLogControllerUpdate$Response(params: VendorWorkspaceApproveLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceApproveLogDto>> {
    return vendorWorkspaceApproveLogControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 승인 로그 수정.
   *
   * 입점사 승인 로그을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceApproveLogControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceApproveLogControllerUpdate(params: VendorWorkspaceApproveLogControllerUpdate$Params, context?: HttpContext): Observable<VendorWorkspaceApproveLogDto> {
    return this.vendorWorkspaceApproveLogControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceApproveLogDto>): VendorWorkspaceApproveLogDto => r.body)
    );
  }

}
